import { render, staticRenderFns } from "./BodyProfitabilityAnalysis.vue?vue&type=template&id=48c2a959&scoped=true"
import script from "./BodyProfitabilityAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyProfitabilityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyProfitabilityAnalysis.vue?vue&type=style&index=0&id=48c2a959&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2a959",
  null
  
)

export default component.exports